import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import { ArrowLeft } from "lucide-react";

import NavBar from "../components/common/navBar";
import Footer from "../components/common/footer";

import INFO from "../data/user";

import "./styles/404.css";

const Notfound = () => {
	useEffect(() => {
		document.title = `404 | ${INFO.main.name}`;
	}, []);

	return (
		<React.Fragment>
			<Helmet>
				<title>{`404 Page Not Found | ${INFO.main.name}`}</title>
			</Helmet>

			<div className="page-content">
				<NavBar />

				<main className="content-wrapper">
					<div className="notfound-container-main">
						<div className="terminal-404-box">
							<div className="terminal-header-bar">
								<span className="terminal-dot red"></span>
								<span className="terminal-dot yellow"></span>
								<span className="terminal-dot green"></span>
								<span style={{ fontFamily: "var(--code-font)", fontSize: "0.75rem", color: "var(--secondary-color)", marginLeft: "auto" }}>
									HTTP status: 404 NOT_FOUND
								</span>
							</div>

							<h1 className="terminal-code">404</h1>

							<p className="terminal-msg">
								This route doesn't exist. But the system is still running smoothly.
							</p>

							<div className="terminal-subtext">
								{`ERR_ROUTE_NOT_FOUND: ${window.location.pathname}`}
							</div>

							<div style={{ marginTop: "12px" }}>
								<Link to="/" className="btn-primary">
									<ArrowLeft size={16} />
									<span>Back to Home</span>
								</Link>
							</div>
						</div>
					</div>

					<div className="page-footer">
						<Footer />
					</div>
				</main>
			</div>
		</React.Fragment>
	);
};

export default Notfound;
